























import { Component, Prop, Vue } from 'vue-property-decorator';

import Modal from 'frontend/components/Modal.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import { isMobile } from 'frontend/legacy/utils';

@Component({
  methods: { isMobile },
  components: {
    Modal,
  },
})
export default class LLPOnboardingModal extends Vue {
  @Prop({ type: Object, required: true })
  private learningPath!: RelatedLearningPathInfo;

  @Prop({ type: String, required: false })
  private readonly ctaUrl?: string;

  private get levelText(): string {
    if (!this.learningPath.is_enrolled) {
      return `Kick-off  your learning journey with Level ${this.learningPath.level_number}:
        ${this.learningPath.level_title}.`;
    }

    if (this.learningPath.level_number === 1) {
      return `You’ll start your learning journey at Level 1: ${this.learningPath.level_title}.
      We’ve saved your previous course progress.`;
    }
    if (
      this.learningPath.level_number !== 1 &&
      this.learningPath.level_number !== this.learningPath.total_levels
    ) {
      return `Your previous course progress has placed you into Level ${this.learningPath.level_number}:
      ${this.learningPath.level_title}.`;
    }
    return `Your previous course progress has placed you into the final level - Level ${this.learningPath.level_number}:
      ${this.learningPath.level_title}.`;
  }

  private get videoSrc(): string {
    if (this.learningPath.slug === 'foundational-math') {
      return '/site_media/version-0/llp_mp4s/LLPAnnouncementMath.mp4';
    }
    if (this.learningPath.slug === 'advanced-math') {
      return '/site_media/version-0/llp_mp4s/LLPAnnouncementAdvMath.mp4';
    }
    if (this.learningPath.slug === 'computer-science') {
      return '/site_media/version-0/llp_mp4s/LLPAnnouncementCompSci.mp4';
    }
    if (this.learningPath.slug === 'data-analysis') {
      return '/site_media/version-0/llp_mp4s/LLPAnnouncementData.mp4';
    }
    if (this.learningPath.slug === 'science') {
      return '/site_media/version-0/llp_mp4s/LLPAnnouncementScience.mp4';
    }
    return '/site_media/version-0/llp_mp4s/LLPAnnouncementScience.mp4';
  }
}
